import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import {
  getAllTaskTypesQueryKey,
  getTaskTypesQueryKey,
  invalidateTaskTypesQueries,
} from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CreateTaskTypeDTO, TaskType } from "../types/TaskType";
import {
  createTaskType,
  deleteTaskType,
  getAllTaskTypes,
  getTaskTypes,
  updateTaskType,
} from "./task-types.service";

export function useAllTaskTypes({
  enabled = true,
}: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: getAllTaskTypesQueryKey(),
    queryFn: getAllTaskTypes,
    staleTime: Infinity,
    gcTime: INTERVAL.DAY,
    enabled,
  });
}

export const useTaskTypes = (ids: string[]) => {
  return useQuery({
    queryKey: getTaskTypesQueryKey(ids),
    queryFn: () => getTaskTypes(ids),
    staleTime: Infinity,
  });
};

export const useCreateTaskType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (taskType: CreateTaskTypeDTO) => createTaskType(taskType),
    onSuccess: () => {
      return invalidateTaskTypesQueries(queryClient);
    },
  });
};

export const useUpdateTaskType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (taskType: TaskType) => updateTaskType(taskType),
    onSuccess: () => {
      return invalidateTaskTypesQueries(queryClient);
    },
  });
};

export const useDeleteTaskType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteTaskType(id),
    onSuccess: () => {
      return invalidateTaskTypesQueries(queryClient);
    },
  });
};
